import type { TripLegKind, TripLegStatus } from '@shared/types';

/**
 * Collapsed travel cards show a short company name only.
 * "My Limo (My Limousine Service, … 973-929-5466, reservations@mylimo.com)"
 * becomes "My Limo". Phone numbers and email stay on the expanded card.
 */
export function shortCarrierName(value: string | null, kind: TripLegKind): string {
  const fallback = kind === 'flight' ? 'United' : 'No company yet';
  if (!value) return fallback;
  const head = value.split('(')[0].replace(/\s+LLC\b/gi, '').replace(/\s+/g, ' ').trim();
  return head.length > 0 ? head : fallback;
}

export function statusLabel(status: TripLegStatus): string {
  if (status === 'needed') return 'NEEDED';
  if (status === 'booked') return 'Booked';
  if (status === 'ticketed') return 'Ticketed';
  if (status === 'rebooked') return 'Rebooked';
  if (status === 'cancel_requested') return 'Cancel requested';
  return status;
}

export function statusBadgeClass(status: TripLegStatus): string {
  if (status === 'needed' || status === 'cancel_requested') return 'badge badge-closed';
  if (status === 'booked') return 'badge badge-open';
  return 'badge badge-neutral';
}

export function legCardClass(kind: TripLegKind, status: TripLegStatus): string {
  if (kind === 'transfer' && status === 'needed') return 'trip-leg trip-leg--needed';
  if (status === 'cancel_requested') return 'trip-leg trip-leg--cancel';
  return 'trip-leg';
}

/** Card-brand plus last digits, when the notes mention how it was paid. */
export function paymentLabel(notes: string | null): string | null {
  if (!notes) return null;
  const match = notes.match(/\b(?:Amex|American Express|Visa|MasterCard|Mastercard)(?:\s+ending)?\s+\d{3,4}\b/i);
  return match ? match[0].replace(/\s+/g, ' ') : null;
}

export function routeLine(origin: string | null, destination: string | null): string {
  return `${origin ?? '—'} → ${destination ?? '—'}`;
}
